var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch18 = function SvgSearch18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.273 12.848c-3.644 2.513-7.896 1.212-9.892-1.526-2.069-2.838-1.792-6.75.687-9.247 2.465-2.48 6.405-2.768 9.216-.694 2.07 1.527 3.233 4.224 2.765 6.94-.311 1.806-.238 3.834 1.058 5.129q1.243 1.239 2.479 2.487c.54.543.55 1.167.04 1.682-.512.516-1.139.51-1.677-.028a2837 2837 0 0 1-4.55-4.563c-.048-.048-.08-.112-.126-.18M2.058 7.082c.001 2.801 2.224 5.047 5.003 5.053 2.794.006 5.037-2.244 5.039-5.056.002-2.774-2.256-5.02-5.042-5.018-2.76.002-5.002 2.254-5 5.02"
  })));
};
export default SvgSearch18;